import { AfterViewInit, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SubmittedRosterRequest } from 'src/app/models/Requests/SubmittedRosterRequest.model';
import { Roster } from 'src/app/models/Roster/roster.model';
import { SaveRosterStudents } from 'src/app/models/Roster/SaveRosterStudents.model';
import { Login } from 'src/app/models/login.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RostersService } from 'src/app/services/rosters.service';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';
import autoTable from  'jspdf-autotable';
@Component({
  selector: 'app-coverage-details',
  templateUrl: './coverage-details.component.html',
  styleUrls: ['./coverage-details.component.scss']
})
export class CoverageDetailsComponent implements AfterViewInit {

  rosterCoverage: Roster;
  coveredStudents: SaveRosterStudents[] = [];
  loggedInUser = new Login("", "", "", "", "", "", 0, false,false,false, "");

  roster: Roster;
  successMsg: string = "";
  isSuccess: boolean = false;

  dispColumns: string[] = ['firstName','middleName', 'lastName', 'studentID', 'dateOfBirth', 'paidPremiumDate', 'paymentMethod', 'checkNumber'];
  dataSource: MatTableDataSource<SaveRosterStudents> = new MatTableDataSource(this.coveredStudents);
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  pageEvent: PageEvent = {
    pageIndex: 0,
    pageSize: 5,
    length: 100
  };
  manualPage: number;
  pageIndex: number = 0;

  pageNumbers: number[] = [];
  noOfPages: number = 0;
  selectedPageNumber : number = 1;
  currenttotalPages:number = 0;
 goTo:number;

  constructor(private rosterService: RostersService, private dialog: MatDialog,
    private cdref: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any, private authService: AuthenticationService,
    private router: Router, private dialogRef: MatDialogRef<CoverageDetailsComponent>,) {
  }

  ngOnInit() {
    this.roster = this.data.roster;
    this.successMsg = this.data.msg;
    if (this.successMsg != '' && this.successMsg != undefined) {
      this.isSuccess = true;
    }
    this.authService.setLogin.subscribe(loginData => {
      this.loggedInUser = loginData;
    });
    this.getCoverageDetails();
    this.getCoveredStudents();
  }

  getCoverageDetails() {
    this.rosterCoverage = new Roster(0, "", "", "", "", "", "", 0, "", 0, "", 0, 0, 0);

    let request = new SubmittedRosterRequest(this.roster.rosterNo, this.loggedInUser.accessId, this.loggedInUser.accessLevel);
    request.userId = this.loggedInUser.userId;
    this.rosterService.getCoverages(request).subscribe({
      next: (result: any) => {
        this.rosterCoverage = result[0];

      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      }
    });
  }
  closeDialog(){
    this.dialogRef.close();
  }

  getCoveredStudents() {
    this.coveredStudents = [];
    this.rosterService.getCoveredStudents(this.roster.rosterNo).subscribe({
      next: (result: any) => {
        this.coveredStudents = result;
        this.dataSource = new MatTableDataSource(this.coveredStudents);
        this.dataSource.paginator = this.paginator;
        this.cdref.detectChanges();
        this.setPageNumbers();
        this.updateGoto();
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      }
    });
  }





  OpenStudentDetailsPopup(element: Roster) {
    if (element != null) {
      this.dialog.open(CoverageDetailsComponent, {
        data: element
      });
    }
  }
  BackToRoster() {
    // this.router.navigate(['/roster']);
    this.dialogRef.close('roster');
  }
  RouteToAddRoster() {
    this.dialogRef.close('roster form');
  }
  printAsPDF() {

     let divRef = document.getElementById('printSection');
    html2canvas(divRef!, {scale: 3}).then(canvas => {

      const imgWidth = 225;
      const pageHeight = 295;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const heightLeft = imgHeight;
      const contentDataURL = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'letter');
      const position = 18;
      pdf.addImage(contentDataURL, "PNG", 10, position, imgWidth, imgHeight, '', 'FAST')
      pdf.text("Coverage Details", 13.5, 15);
      // pdf.save('MYPdf.pdf');
      // pdf.addPage();
      pdf.text("Student Details", 13.5, 100);
      var prepare: any[]=[];
    this.coveredStudents.forEach(student=>{
      const studentC =
        [
          student.firstName,
          student.middleName,
          student.lastName,
          student.ssn,
          formatDate(new Date(student.dob!), 'MM/dd/yyyy', 'en-IN'),
          formatDate(new Date(student.paidDate!), 'MM/dd/yyyy', 'en-IN'),
          student.paymentMethod,
          student.checkNo,
        ]
      prepare.push(studentC);
    });

    autoTable(pdf, {
        head: [['First Name','Middle Name','Last Name','Student ID','Date of Birth','Date Student Paid Premium','Student Payment Method','Check Number']],
        margin: { left: 5, right: 5 },
        bodyStyles: { fontSize: 9 },
        body: prepare,
        startY: 110,
        didDrawCell: (prepare)=>{}
    });
    pdf.save('Coverage-Student-Details' + '.pdf');

    })
    .then((pdf)=>{

    })

    var doc = new jsPDF();
    const coverageDetails = this.extractData();
    doc.addPage(JSON.stringify(coverageDetails));

  }

  extractData(): any[] {

    const coverage = [

      {
        'Activity': this.rosterCoverage.activity,
        'Demographics': this.rosterCoverage.demographics,
        'Marketing Plan': this.rosterCoverage.marketingPlan,
        'Plan Rate': this.rosterCoverage.planRate,
        'Student Rate': this.rosterCoverage.studentRate,
        'Check No': this.rosterCoverage.checkNo,
        'Check Amount': this.rosterCoverage.checkAmt,
        'Check Date': formatDate(new Date(this.rosterCoverage.checkDate!), 'MM/dd/yyyy', 'en-IN'),
      }
    ]
    return coverage;
  }

  printAsExcel() {
    const data = this.extractData();
    const rosterInfo: any[] = [];
    rosterInfo.push([
      'Roster Number',
      'Campus Name'
    ]);
    rosterInfo.push([
      this.rosterCoverage.rosterNo,
      this.rosterCoverage.campusName
    ]);
    var students: any[]=[];
    students.push([
      'First Name',
      'Middle Name',
      'Last Name',
      'Student ID',
      'Date of Birth',
      'Date Student Paid Premium',
      'Student Payment Method (Cash, Check/M.O.)',
      'Check Number'
    ]);

    this.coveredStudents.forEach(student=>{
      const studentC =
        [
          student.firstName,
          student.middleName,
          student.lastName,
          student.ssn,
          formatDate(new Date(student.dob!), 'MM/dd/yyyy', 'en-IN'),
          formatDate(new Date(student.paidDate!), 'MM/dd/yyyy', 'en-IN'),
          student.paymentMethod,
          student.checkNo,
        ];
        students.push(studentC);
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(rosterInfo);

    XLSX.utils.sheet_add_json(worksheet, data, { origin: 3});
    XLSX.utils.sheet_add_aoa(worksheet, students, { origin: 6 });
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Student Details');

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const a: HTMLAnchorElement = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = 'Student Details';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
  }
  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.coveredStudents);
    this.dataSource.paginator = this.paginator;
}
  updateGoToPage() {

    this.paginator.pageIndex = this.goTo - 1;
  }

  goToChange() {
    this.paginator.pageIndex = this.goTo - 1;
    const event: PageEvent = {
      length: this.paginator.length,
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize
    };
    this.paginator.page.next(event);
  }

  updateGoto() {
    this.goTo = (this.pageIndex || 0) + 1;
    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.paginator?.length/ this.paginator?.pageSize); i++) {
      this.pageNumbers.push(i);
    }
  }
  onPaginateChange(event:any){
    this.selectedPageNumber = event.pageIndex +1;
    this.setPageNumbers();
  }

  setPageNumbers(){
    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.paginator?.length/ this.paginator?.pageSize); i++) {
      this.pageNumbers.push(i);
    }
    this.currenttotalPages = this.pageNumbers.length;
  }

}
